import(/* webpackMode: "eager", webpackExports: ["HomeLink"] */ "/vercel/path0/api/src/app/(site)/_components/home-link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
